import { extensionEditorStyles } from '@bingads-webui-campaign-react/common-styles';
// import { AdPreviewOverideStylesByKey } from '../../common/constants';

const IndicatorWidth = 10;
const IndicatorsGap = 8;

const getIndicatorsWidth = placements => (placements * IndicatorWidth) + ((placements - 1) * IndicatorsGap);

export const getStyles = (_, { palette = {} }) => ({
  '@global': {
    '& .app-content-container-col .default-layout': {
      'overflow-y': 'hidden',
    },
    ...extensionEditorStyles({ palette }),
  },
  assetGroupStepShell: {
    width: '100%',
  },
  'assetGroupStepShell-l': {
    width: 'calc(100% - 64px)',
  },
  imagePreviewCarousel: {
    position: 'sticky',
    width: 420,
    top: '0px',
    '& .ad-placement-preview': {
      height: 450,
    },
    '& .new-preview-carousel-container-adprelib': {
      // backgroundColor: '#ffffff',
      border: '1px solid #C8C8C8 !important',
      // borderRadius: '4px',
      // boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      // maxWidth: '420px',
      minWidth: 'unset !important',

      '& .preview-string': {
        display: 'none',
      },

      '& .ad-preview-actions': {
        display: 'flex',
      },
      '& .carousel-inner': {
        height: 450,
      },

      '& .carousel-indicators': {
        display: 'flex',
        gap: '8px',
        left: '50% !important',
        margin: '48px 0 !important',
        transform: 'translateX(-50%)',

        '& li': {
          margin: '0',
        },
      },

      '& .carousel-control': {
        display: 'flex',
        width: '12px',
        margin: '12px 0 !important',
        left: '50% !important',
      },

      '& .carousel-control.left': {
        transform: ({ placements }) => {
          const transformations = [];

          // Move left arrow to the center
          transformations.push('translateX(-50%)');

          // Move left arrow to the left of the indicators
          const indicatorsWidth = getIndicatorsWidth(placements);
          transformations.push(`translateX(-${indicatorsWidth / 2}px)`);

          // Add extra space between the left arrow and the indicators
          transformations.push('translateX(-47px)');

          return transformations.join(' ');
        },
        bottom: 16,
      },

      '& .carousel-control.right': {
        transform: ({ placements }) => {
          const transformations = [];

          // Move right arrow to the center
          transformations.push('translateX(-50%)');

          // Move right arrow to the right of the indicators
          const indicatorsWidth = getIndicatorsWidth(placements);
          transformations.push(`translateX(${indicatorsWidth / 2}px)`);

          // Add extra space between the right arrow and the indicators
          transformations.push('translateX(43px)');

          return transformations.join(' ');
        },
        bottom: 16,
      },

      '& .ad-preview-title': {
        height: '24px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        '& .preview-title-string-key': {
          color: '#323130',
          fontSize: '14px',
          fontWeight: 700,
          marginRight: '8px',
        },

        '& .preview-title-preview-type': {
          fontSize: '14px',
        },
      },

      '& .ad-placement-preview': {
        overflow: 'hidden',

        '& .card-parent': {
          width: '100%',
        },

        '& .responsive-ad-preview-content': {
          boxSizing: 'border-box',
          width: '100%',
        },
      },
      '& .ad-placement-preview.app-ad-windows': {
        '& .card-parent': {
          '& .responsive-ad-preview-content': {
            height: 'fit-content',
            width: 'fit-content',
            maxWidth: '100%',
            '& .text-container-apl': {
              maxWidth: 'calc(100% - 25px)',
            },
          },
        },
      },
      '& .ad-placement-preview.app-ad-start-menu': {
        '& .new-responsive-ad-preview-container': {
          height: '100%',
          width: '100%',
        },
      },
      '& .ad-placement-preview.mma_191x100': {
        '& .card-parent': {
          // maxWidth: AdPreviewOverideStylesByKey.mma_191x100.imagePreviewWidth,
          '& .text-container-apl': {
            padding: '5px 12px 12px 12px',
            '& .short-headline': {
              wordWrap: 'break-word',
            },
            '& .final-url': {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          },
        },
      },

      '& .ad-placement-preview.edge_178x100': {
        '& .card-parent': {
          '& .responsive-ad-preview-content': {
            height: 'fit-content',
            width: 'fit-content',
            maxWidth: '100%',
            '& .text-container-apl': {
              maxWidth: 'calc(100% - 25px)',
            },
          },
        },
      },

      '& .ad-placement-preview.msan_191x100': {
        '& .card-parent': {
          // maxWidth: AdPreviewOverideStylesByKey.msan_191x100.imagePreviewWidth,
        },
      },

      '& .ad-placement-preview.msan_150x100': {
        '& .card-parent': {
          // maxWidth: AdPreviewOverideStylesByKey.msan_150x100.imagePreviewWidth,
        },
      },

      '& .ad-placement-preview.msan_1x1': {
        padding: 20,
      },

      '& .ad-placement-preview.msan_133x100': {
        padding: 20,
      },

      '& .ad-placement-preview.bing_text': {
        '& .responsive-ad-preview-content': {
          '& .text-container-apl': {
            '& .final-url > .multi-line-processed-text': {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          },
        },
      },

      '& .ad-placement-preview.outlook_text_mobile': {
        '& .responsive-ad-preview-content': {
          boxSizing: 'content-box',
          maxWidth: 'calc(100% - 50px)',
          '& .description': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            whiteSpace: 'nowrap',
          },
        },
      },

      '& .ad-placement-preview.outlook_text_web': {
        padding: '0px 8px',

        '& .responsive-ad-preview-content': {
          display: 'flex',
          flexDirection: 'row',
          minWidth: 0,
          '& .text-container-apl': {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            minWidth: 0,
            '& .pre-headline-divider': {
              height: 2,
            },
            '& .description-parent': {
              flex: '1 1 0px',
              minWidth: 0,
              '& .description': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
              },
            },
          },

          '& .business-name-with-ads': {
            marginRight: 10,
          },
        },
      },
    },
  },
  'imagePreviewCarousel-xxl': {
    '@media (min-width: 1400px)': {
      width: 530,
    },
    width: 420,
  },
  'imagePreviewCarousel-xl': {
    width: 420,
  },
  rightStyles: {
    // '@media (min-width: 1750px)': {
    //   width: '50%',
    // },
    '& .image-experience-content': {
      minWidth: 'unset !important',
    },
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '32px',
    '& .text-input-container': {
      width: '100% !important',
    },
    '& .title-item': {
      width: 'auto',
      maxWidth: '100%',
    },
  },
  leftStyles: {
    width: '100%',
    maxWidth: '530px',
  },
  'leftStyles-xxl': {
    width: '530px',
  },
  'leftStyles-xl': {
    width: '600px',
  },
  headerStackStyles: {
    width: 'unset',
  },
  'headerStackStyles-l': {
    width: '600px',
  },
  'headerStackStyles-xl': {
    width: '600px',
  },
  'headerStackStyles-xxl': {
    width: '530px',
  },
  imageExperienceStyle: {
    '& .image-experience-content': {
      minWidth: 'unset !important',
    },
    '& .image-list-choice-group .ms-ChoiceFieldGroup-flexContainer': {
      width: 'unset !important',
    },
  },
  textAssetStyle: {
    '& .text-assets-collection-container': {
      width: '100%',
      // '@media (max-width: 1750px)': {
      //   width: 'unset !important',
      // },
    },
  },
  businessNameStyle: {
    '& .business-name-container': {
      width: '100%',
      // '@media (max-width: 1750px)': {
      //   width: 'unset !important',
      // },
    },
  },
  imageListLoadingContainer: {
    minHeight: 84,
    '& .loading': {
      paddingTop: 30,
    },
  },
  imageListErrorContainer: {
    paddingTop: 10,
    '& .alert': {
      alignItems: 'center',
      padding: [4, 16, 4, 12],

      '& .alert-image:before': {
        lineHeight: '32px',
      },

      '& .alert__content': {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center',
      },

      '& .alert__action': {
        marginLeft: 'auto',
        marginTop: 'unset',
      },
    },
  },
  imageAssetDescription: {
    marginBottom: 5,
    display: 'flex',
  },
});
